"use client";
import React, { useState, useEffect } from "react";

const TextFieldComp = ({
  placeholder,
  value,
  onChange,
  readOnly = false,
  maxLength,
  type = "text",
  background = "#F2F8FF66",
  textColor = "#1E2125",
  heightClass = "h-[40px]",
}) => {
  return (
    <div
      className={`${heightClass} rounded-[6px] mt-[4px]   shadow-custom-dark-to-white w-full`}
      style={{ background: background }}
    >
      <input
        type={type}
        value={value || ""}
        onChange={onChange}
        className="w-full px-[19px] h-full bg-transparent text-[15px] "
        placeholder={placeholder}
        readOnly={readOnly}
        maxLength={maxLength}
        style={{ color: textColor }}
      />
    </div>
  );
};

export default TextFieldComp;
